export const ATTN_DATA_ATTR = 'data-attentive-popup';
